module.exports = __webpack_public_path__ + "static/media/ElementInfoCards.77d39396.png";